import React, {Component} from 'react';
import {Button} from 'antd';
import CameraModalForm from './CameraModalForm'

class CameraButtonUpdate extends Component {
  state = {
    visible: false
  };
  showModal = () => {
    this.setState({visible: true});
  };
  handleCancel = () => {
    this.setState({visible: false});
  };
  handleUpdate = () => {
    const form = this.form;
    form.validateFields((err, values) => {
      if (err) {
        return;
      }
      this.props.onUpdate(values)
      form.resetFields();
      this.setState({visible: false});
    });
  };
  saveFormRef = (form) => {
    this.form = form;
  };
  render() {
    const {camera, categories} = this.props
    return (<span>
      <Button onClick={this.showModal} type="primary" ghost="ghost" size="small">
        Edit
      </Button>
      <CameraModalForm title="Cập nhật camera" camera={camera} categories={categories} ref={this.saveFormRef} visible={this.state.visible} onCancel={this.handleCancel} onSubmit={this.handleUpdate}/>
    </span>);
  }
}

export default CameraButtonUpdate;



// WEBPACK FOOTER //
// ./src/components/CameraButtonUpdate.js